export const makeValidated = schema => action => {
  if (process.env.NODE_ENV === 'development') {
    const { makeJsonSchemaValidator } = require('../../utils/json');
    const validate = makeJsonSchemaValidator(schema);
    const { valid, errors } = validate(action);
    if (valid === false) {
      throw new Error(
        [`Invalid "${action.type}" action structure!`, ...errors].join('\n')
      );
    }
    return action;
  } else {
    return action;
  }
};
